import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

const Faq = () => (
  <div>
    <PageHeader
      eyebrow="FAQs"
      title="Answers to common questions"
      subtitle="Everything you need to know about our machines, retrofits and services."
    />
    <section className="py-12 md:py-20">
      <div className="max-w-[820px] mx-auto px-6 md:px-12">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-[#0055FF]/30 rounded-2xl border-slate-200 px-6" data-testid={`faq-${i}`}>
                <AccordionTrigger className="text-left text-lg hover:no-underline py-6">{f.q}</AccordionTrigger>
                <AccordionContent className="text-dim leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Faq;
